import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import ReadyToShip from './pages/ReadyToShip';
import CustomOrder from './pages/CustomOrder';
import Shipping from './pages/Shipping';
import Returns from './pages/Returns';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsOfService from './pages/TermsOfService';
import Navigation from './components/Navigation';
import FAQ from './pages/FAQ';
import Gallery from './pages/Gallery';

function App() {
  return (
    <Router>
      {/* Our site’s navigation */}
      <Navigation />

      {/* Our page routes */}
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/ready-to-ship" element={<ReadyToShip />} />
        <Route path="/custom-order" element={<CustomOrder />} />
        <Route path="/shipping" element={<Shipping />} />
        <Route path="/returns" element={<Returns />} />
        <Route path="/privacy" element={<PrivacyPolicy />} />
        <Route path="/terms" element={<TermsOfService />} />
        <Route path="/faq" element={<FAQ />} /> 
        <Route path="/gallery" element={<Gallery />} />  
      </Routes>
    </Router>
  );
}

export default App;